import React, { useState } from "react";
import Button from "../button";
import BaseModal from "../modal/base/BaseModal";

type DialogProps = {
  close: () => void;
  defaultValue?: string;
  maxLength?: number;
  onConfirm?: (nickname: string) => void;
};

const NicknameDialog = (props: DialogProps) => {
  const { close, defaultValue = "", maxLength = 8, onConfirm } = props;
  const [nickname, setNickname] = useState(defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNickname(e.target.value.slice(0, maxLength));
  };

  const handleConfirm = () => {
    // 모달 닫기는 호출부(성공 alert 확인)에서 처리
    onConfirm?.(nickname.trim());
  };

  return (
    <BaseModal className="p-[20px] rounded-none" size="dialog" close={close}>
      <section className="flex flex-col min-h-[154px] justify-between">
        <p className="text-base font-semibold text-center mb-[10px]">
          닉네임 변경
        </p>
        <p className="text-[#8e8e93] text-sm font-[500] whitespace-pre-line break-keep text-center">
          부적절한 닉네임 등록 시, 관리자에 의해 예고 없이 변경될 수 있습니다.
        </p>

        {/* 닉네임 입력 */}
        <div className="space-y-[4px] mb-[30px]">
          <p className="text-right text-xs">
            <span>{nickname.length}</span>
            <span className="text-[#888]">/{maxLength}</span>
          </p>
          <input
            value={nickname}
            onChange={handleChange}
            maxLength={maxLength}
            placeholder="닉네임을 입력해 주세요."
            className="w-full min-h-[40px] rounded-[8px] border border-[#d9d9d9] px-[16px] font-normal text-base outline-none focus:ring-1 focus:ring-black py-[12px]"
          />
        </div>

        <div className="flex justify-center gap-x-[8px] mx-auto">
          <Button
            className="text-base font-normal px-[22.5px] py-[12px]"
            label="취소"
            variant={"white"}
            onClick={close}
          />
          <Button
            className="text-base font-normal px-[22.5px] py-[12px]"
            label="변경"
            variant={"black"}
            disabled={nickname.trim().length === 0}
            onClick={handleConfirm}
          />
        </div>
      </section>
    </BaseModal>
  );
};

export default React.memo(NicknameDialog);
